<template>
    <div id="list-clinic">
        <div class="row topactionform">
            <div class="col-xs-4" style="padding-right: 0">
                <div class="smalltitle">List {{getPageName}}</div>
            </div>
            <div class="col-xs-8">
                <form class="onelineform flowsearch" @submit.prevent="filterDoctor">
                    <button type="submit" class="submit btn light" style="float: right; width: 10%"><i
                            class="fa fa-search"></i></button>
                    <span class="selectwrap" style="width: 15%; float: right">
                        <select v-model="formSearch.status" @change="filterDoctor">
                            <option value="">Account status</option>
                            <option :value="STATUS_ACTIVE">Activated</option>
                            <option value="0">Deactivated</option>
                        </select>
                    </span>
                    <input type="text" placeholder="Name or leave blank for search all"
                           v-model="formSearch.keySearch"
                           class="keyinput" style="width: 35%; border-left: 1px solid #e1e1e1; float: right">
                </form>
            </div>
        </div>
        <div class="blockcont">
            <ul class="itemlisttable  ptemr-list">
                <li class="itemlisthead">
                    <div class="item-name">Full Name</div>
                    <div class="item-created-at">Created</div>
                    <div class="item-provider">Provider</div>
                    <div class="item-provider">Staff</div>
                    <div class="item-account-status">Account status</div>
                    <div class="item-account-status">Email status</div>
                    <div class="item-emr-status">EMR status</div>
                    <div class="item-proof">ID Proof</div>
                    <div class="item-emr-service">Bank</div>
                    <div class="item-action">Action</div>
                </li>
                <li v-if="isLoading" style="text-align: center; color: #d9df20; font-size: 16pt"><i
                        class="fas fa-spinner fa-spin"></i></li>
                <li v-if="!isLoading && dataDoctors.length === 0" style="text-align: center; font-size: 16pt">
                    No records found
                </li>

                <li v-if="!isLoading" class="item-doctor" v-for="(doctor, index) in dataDoctors">
                    <div class="item-name">
                        <span class="item-folder" :class="{'opened': doctor.opened}"
                              @click="showListMember(doctor)"></span>
                        <span @click="showDetailUser(doctor)">
                             <div class="avatar-user"
                                  :style="'background-image: url('+doctor.avatar+')'"></div>
                        {{doctor.fullName}}
                        </span>
                    </div>
                    <div class="item-created-at">{{formatTime(doctor.createdAt)}}</div>
                    <div class="item-provider">N/A</div>
                    <div class="item-provider">N/A</div>
                    <div class="item-account-status">{{getStatusText(doctor.status)}}</div>
                    <div class="item-account-status">N/A</div>
                    <div class="item-emr-status">{{getStatusText(doctor.emr_status)}}</div>
                    <div class="item-proof" @click.prevent="showIdProof(doctor)"><i class="fas fa-fingerprint"></i></div>
                    <div class="item-emr-service" :title="doctor.stripeBankLabel || 'No bank account on file'">
                        <span v-if="doctor.stripeBankLabel" class="bank-linked">{{doctor.stripeBankLabel}}</span>
                        <span v-else class="bank-missing">Not linked</span>
                    </div>
                    <div class="item-action itemaction clinic-actions">
                        <div class="btn-group dropdown"><a href="javascript:void(0)" @click.prevent="showModalCreatePackage(doctor)">
                            <i class="fa fa-list-alt"></i> Order Package </a>
                        </div>
                        <div class="btn-group dropdown"><a href="javascript:void(0)" @click.prevent="showModalInvoices(doctor)">
                            <i class="fa fa-file-invoice-dollar"></i> Invoices </a>
                        </div>
                        <dropdown class="clinic-settings">
                            <a href="javascript:void(0)" title="Action" data-toggle="dropdown">
                                <i class="fa fa-cog"
                                   aria-hidden="true"></i></a>
                            <template slot="dropdown">
                                <div><a :href="getLinkProfileAccount(doctor.id)"
                                        target="_blank"
                                        >Profile</a>
                                </div>
                                <div><a href="javascript:void(0)"
                                        @click.prevent="loginAsEmr(doctor)">Login as EMR</a>
                                </div>
                                <div><a href="javascript:void(0)"
                                        @click.prevent="changeStatusAccount(doctor)">{{getStatusAccountAction(doctor)}}</a>
                                </div>
                                <div><a href="javascript:void(0)"
                                        @click.prevent="changeStatusEmr(doctor)">{{getStatusEmrAction(doctor)}}</a>
                                </div>
                              <div><a href="javascript:void(0)"
                                      @click.prevent="showModalSetNewPassword(doctor)">Set new password</a>
                              </div>
                              <div>
                                <a href="javascript:void(0)"
                                   @click.prevent="showModalCloneFromOtherDoctor(doctor)">Import Setting from Other Doctor</a>
                              </div>
                              <div>
                                <a href="javascript:void(0)"
                                   @click.prevent="showModalAddStaff(doctor)">Add staff</a>
                              </div>
                            </template>
                        </dropdown>
                    </div>

                    <div class="itemlisttable  list-members" v-if="doctor.opened">
                        <div class="block-member block-physician">
                            <div class="itemlisttable  ptemr-list">
                                <div class="itemlisthead">
                                    <div class="item-member-name">PHYSICIAN <span
                                            v-if="doctor.paginatePhysician.total">({{doctor.paginatePhysician.total}})</span>
                                    </div>
                                    <div class="item-member-dob">Dob</div>
                                    <div class="item-member-created-at">Created</div>
                                    <div class="item-action">Action</div>
                                    <div class="clearfix"></div>
                                </div>
                                <div v-if="doctor.isLoadingPhysician" style="text-align: center; color: #d9df20;"><i
                                        class="fas fa-spinner fa-spin"></i></div>
                                <div class="item-member" v-for="(member, index) in doctor.listPhysician">
                                    <div class="item-member-name">
                                        <span @click="showDetailUser(member)">
                                          <div class="avatar-user"
                                               :style="'background-image: url('+member.avatar+')'"></div> {{member.fullName}}
                                        </span>
                                        <div class="member-join-status"
                                             :class="{'not-confirmed': Number(member.status) !== STATUS_JOIN_CONFIRMED}">
                                            {{getJoinClinicStatusText(member.status)}}
                                        </div>
                                    </div>
                                    <div class="item-member-dob">
                                        {{formatAgeFromBirthday(member.birthDay)}}
                                        <span v-if="member.gender" title="Sex">{{member.gender}}</span>
                                        <div style="font-weight: normal !important; font-size: 10px !important;"
                                             title="Date of Birth">{{formatTime(member.birthDay)}}
                                        </div>
                                    </div>
                                    <div class="item-member-created-at">{{formatTime(member.createdAt)}}</div>
                                    <div class="item-member-account-status">{{getStatusText(member.wStatus)}}</div>
                                    <div class="item-member-emr-status">{{getStatusText(member.emr_status)}}</div>
                                    <div class="item-action">
                                      <dropdown append-to-body menu-right>
                                        <a href="javascript:void(0)" title="Action" data-toggle="dropdown">
                                          <i class="fa fa-cog"
                                             aria-hidden="true"></i></a>
                                        <template slot="dropdown">
                                          <div>
                                            <a v-if="Number(member.status) === STATUS_JOIN_WAITING"
                                               @click.prevent="activeJoinClinic(member, doctor)"
                                                  target="_blank"
                                          >Accept join clinic
                                            </a>
                                          </div>
                                          <div>
                                            <a href="javascript:void(0)"
                                               @click.prevent="loginAsEmr(member)">Login as EMR</a>
                                          </div>
                                        </template>
                                      </dropdown>
                                    </div>
                                    <div class="clearfix"></div>
                                </div>
                            </div>
                            <pagination v-if="doctor.listPhysician.length" :currentPage="doctor.paginatePhysician.page"
                                        :perPage="doctor.paginatePhysician.perPage"
                                        @updatePerPage="updatePerPageDoctor($event, doctor,'physician')"
                                        :totalPages="doctor.paginatePhysician.totalPages"
                                        :total="doctor.paginatePhysician.total">
                            </pagination>
                        </div>
                        <div class="clearfix"></div>
                        <div class="block-member block-staff">
                            <div class="itemlisttable  ptemr-list">
                                <div class="itemlisthead">
                                    <div class="item-member-name">Staff <span
                                            v-if="doctor.paginateStaff.total">({{doctor.paginateStaff.total}})</span>
                                    </div>
                                    <div class="item-member-dob">Dob</div>
                                    <div class="item-member-created-at">Created At</div>
                                    <div class="item-action">Action</div>
                                    <div class="clearfix"></div>
                                </div>
                                <div v-if="doctor.isLoadingStaff" style="text-align: center; color: #d9df20;"><i
                                        class="fas fa-spinner fa-spin"></i></div>
                                <div class="item-member" v-for="(member, index) in doctor.listStaff">
                                    <div class="item-member-name">
                                        <span @click="showDetailUser(member)">
                                          <div class="avatar-user"
                                               :style="'background-image: url('+member.avatar+')'"></div> {{member.fullName}}
                                        </span>
                                        <div class="member-join-status"
                                             :class="{'not-confirmed': Number(member.status) !== STATUS_JOIN_CONFIRMED}">
                                            {{getJoinClinicStatusText(member.status)}}
                                        </div>
                                    </div>
                                    <div class="item-member-dob">
                                        {{formatAgeFromBirthday(member.birthDay)}}
                                        <span v-if="member.gender" title="Sex">{{member.gender}}</span>
                                        <div style="font-weight: normal !important; font-size: 10px !important;"
                                             title="Date of Birth">{{formatTime(member.birthDay)}}
                                        </div>
                                    </div>
                                    <div class="item-member-created-at">{{formatTime(member.createdAt)}}</div>
                                    <div class="item-member-account-status">{{getStatusText(member.wStatus)}}</div>
                                    <div class="item-member-emr-status">{{getStatusText(member.emr_status)}}</div>
                                    <div class="item-action"></div>
                                    <div class="clearfix"></div>
                                </div>
                            </div>
                            <pagination v-if="doctor.listStaff.length" :currentPage="doctor.paginateStaff.page"
                                        :perPage="doctor.paginateStaff.perPage"
                                        @updatePerPage="updatePerPageDoctor($event, doctor,'staff')"
                                        :totalPages="doctor.paginateStaff.totalPages"
                                        :total="doctor.paginateStaff.total">
                            </pagination>
                        </div>
                        <div class="clearfix"></div>
                        <div class="block-member block-mid-level">
                            <div class="itemlisttable  ptemr-list">
                                <div class="itemlisthead">
                                    <div class="item-member-name">Mid Level Provider <span
                                            v-if="doctor.paginateMidLevel.total">({{doctor.paginateMidLevel.total}})</span>
                                    </div>
                                    <div class="item-member-dob">Dob</div>
                                    <div class="item-member-created-at">Created At</div>
                                    <div class="item-action">Action</div>
                                    <div class="clearfix"></div>
                                </div>
                                <div v-if="doctor.isLoadingMidLevel" style="text-align: center; color: #d9df20;"><i
                                        class="fas fa-spinner fa-spin"></i></div>
                                <div class="item-member" v-for="(member, index) in doctor.listMidLevel">
                                    <div class="item-member-name">
                                        <span @click="showDetailUser(member)">
                                          <div class="avatar-user"
                                               :style="'background-image: url('+member.avatar+')'"></div> {{member.fullName}}
                                        </span>
                                        <div class="member-join-status"
                                             :class="{'not-confirmed': Number(member.status) !== STATUS_JOIN_CONFIRMED}">
                                            {{getJoinClinicStatusText(member.status)}}
                                        </div>
                                    </div>
                                    <div class="item-member-dob">
                                        {{formatAgeFromBirthday(member.birthDay)}}
                                        <span v-if="member.gender" title="Sex">{{member.gender}}</span>
                                        <div style="font-weight: normal !important; font-size: 10px !important;"
                                             title="Date of Birth">{{formatTime(member.birthDay)}}
                                        </div>
                                    </div>
                                    <div class="item-member-created-at">{{formatTime(member.createdAt)}}</div>
                                    <div class="item-member-account-status">{{getStatusText(member.wStatus)}}</div>
                                    <div class="item-member-emr-status">{{getStatusText(member.emr_status)}}</div>
                                    <div class="item-action"></div>
                                    <div class="clearfix"></div>
                                </div>
                            </div>
                            <pagination v-if="doctor.listMidLevel.length" :currentPage="doctor.paginateMidLevel.page"
                                        :perPage="doctor.paginateMidLevel.perPage"
                                        @updatePerPage="updatePerPageDoctor($event, doctor,'midLevel')"
                                        :totalPages="doctor.paginateMidLevel.totalPages"
                                        :total="doctor.paginateMidLevel.total">
                            </pagination>
                        </div>
                        <div class="clearfix"></div>
                        <div class="block-member  block-board">
                            <div class="itemlisttable  ptemr-list">
                                <div class="itemlisthead">
                                    <div class="item-member-name">Board <span
                                            v-if="doctor.paginateBoard.total">({{doctor.paginateBoard.total}})</span>
                                    </div>
                                    <div class="item-member-dob">Dob</div>
                                    <div class="item-member-created-at">Created At</div>
                                    <div class="item-action">Action</div>
                                    <div class="clearfix"></div>
                                </div>
                                <div v-if="doctor.isLoadingBoard" style="text-align: center; color: #d9df20;"><i
                                        class="fas fa-spinner fa-spin"></i></div>
                                <div class="item-member" v-for="(member, index) in doctor.listBoard">
                                    <div class="item-member-name">
                                        <span @click="showDetailUser(member)">
                                          <div class="avatar-user"
                                               :style="'background-image: url('+member.avatar+')'"></div> {{member.fullName}}
                                        </span>
                                        <div class="member-join-status"
                                             :class="{'not-confirmed': Number(member.status) !== STATUS_JOIN_CONFIRMED}">
                                            {{getJoinClinicStatusText(member.status)}}
                                        </div>
                                    </div>
                                    <div class="item-member-dob">
                                        {{formatAgeFromBirthday(member.birthDay)}}
                                        <span v-if="member.gender" title="Sex">{{member.gender}}</span>
                                        <div style="font-weight: normal !important; font-size: 10px !important;"
                                             title="Date of Birth">{{formatTime(member.birthDay)}}
                                        </div>
                                    </div>
                                    <div class="item-member-created-at">{{formatTime(member.createdAt)}}</div>
                                    <div class="item-member-account-status">{{getStatusText(member.wStatus)}}</div>
                                    <div class="item-member-emr-status">{{getStatusText(member.emr_status)}}</div>
                                    <div class="item-action"></div>
                                    <div class="clearfix"></div>
                                </div>
                            </div>
                            <pagination v-if="doctor.listBoard.length" :currentPage="doctor.paginateBoard.page"
                                        :perPage="doctor.paginateBoard.perPage"
                                        @updatePerPage="updatePerPageDoctor($event, doctor,'board')"
                                        :totalPages="doctor.paginateBoard.totalPages"
                                        :total="doctor.paginateBoard.total">
                            </pagination>
                        </div>
                    </div>
                    <div class="clearfix"></div>
                </li>
            </ul>
        </div>
        <pagination :currentPage="paginate.page" :perPage="paginate.perPage" @updatePerPage="updatePerPage"
                    :totalPages="paginate.totalPages" :total="paginate.total">
        </pagination>

        <detail-clinic
                v-if="detailClinic.modal"
                :user="detailClinic.user"
                @updateModal="detailClinic.modal = $event"
        >
        </detail-clinic>

        <detail-group
                v-if="detailGroup.modal"
                :user="detailGroup.user"
                @updateModal="detailGroup.modal = $event"
        >
        </detail-group>
        <detail-regular-user
                v-if="detailRegular.modal"
                :user="detailRegular.user"
                @updateModal="detailRegular.modal = $event"
        >
        </detail-regular-user>

        <detail-doctor
                v-if="detailDoctor.modal"
                :user="detailDoctor.user"
                @updateModal="detailDoctor.modal = $event"
        >
        </detail-doctor>
        <id-proof-modal
                v-if="detailIdProof.modal"
                :user="detailIdProof.user"
                @updateModal="detailIdProof.modal = $event"
        >
        </id-proof-modal>
        <order-package-modal
        v-if="orderPackageData.modal"
        @updateModal="orderPackageData.modal = $event"
        :clinic="orderPackageData.clinic">
        </order-package-modal>
        <clinic-invoices-modal
        v-if="invoicesData.modal"
        @updateModal="invoicesData.modal = $event"
        @bankChanged="invoicesData.clinic.stripeBankLabel = $event"
        :clinic="invoicesData.clinic">
        </clinic-invoices-modal>
      <set-new-password v-if="dataNewPassword.modal"
                        @updateModal="dataNewPassword.modal = $event"
                        :user="dataNewPassword.user"
      >
      </set-new-password>
      <add-staff-modal
          v-if="dataAddStaff.modal"
          @updateModal="dataAddStaff.modal = $event"
          @addStaff="reloadMemberOfClinic(dataAddStaff.clinic)"
          :clinic="dataAddStaff.clinic"
      >
      </add-staff-modal>
      <clone-setting-from-doctor
          v-if="dataCloneFromDoctor.modal"
          @updateModal="dataCloneFromDoctor.modal = $event"
          :toDoctor="dataCloneFromDoctor.toDoctor"
          :typeUser="'clinic'"
      >
      </clone-setting-from-doctor>
    </div>
</template>

<script>
import Pagination from '../../global/Pagination.vue'
import axios from '../../client'
import moment from 'moment'
import config from '../../config'
import Vue from 'vue'
import { mapGetters } from 'vuex'
import CommonMixin from '../../mixins/general/CommonMixin.vue'
import TimeMixin from '../../mixins/general/TimeMixin.vue'
import UserStatusMixin from '../../mixins/user/UserStatusMixin.vue'
import httpClient from "@/client";
const DetailClinic = () => import('./part/DetailClinic')
const DetailGroup = () => import('./part/DetailGroup')
const DetailRegularUser = () => import('./part/DetailRegularUser')
const DetailDoctor = () => import('./part/DetailDoctor')
const IdProofModal = () => import('./part/IdProofModal')
const OrderPackageModal = () => import('./part/OrderPackageModal')
const ClinicInvoicesModal = () => import('./part/ClinicInvoicesModal')
const SetNewPassword = () => import('./part/SetNewPassword')

const CloneSettingFromDoctor = () => import('./part/CloneSettingFromDoctor.vue')
const AddStaffModal = () => import('./part/AddStaffModal')
export default {
  name: 'Clinic',
  components: {
    Pagination,
    DetailClinic,
    DetailGroup,
    DetailRegularUser,
    DetailDoctor,
    IdProofModal,
    OrderPackageModal,
    ClinicInvoicesModal,
    SetNewPassword,
    CloneSettingFromDoctor,
    AddStaffModal
  },
  mixins: [CommonMixin, TimeMixin, UserStatusMixin],
  data () {
    return {
      typePage: 'LIST_CLINIC',
      paginate: {
        perPage: 10,
        page: 1,
        totalPages: 10,
        total: 0
      },
      isLoading: false,
      dataDoctors: [],
      formSearch: {
        keySearch: '',
        status: ''
      },
      detailClinic: {
        modal: false,
        user: {}
      },
      detailGroup: {
        modal: false,
        user: {}
      },
      detailRegular: {
        modal: false,
        user: {}
      },
      detailDoctor: {
        modal: false,
        user: {}
      },
      detailIdProof: {
        modal: false
      },
      orderPackageData: {
        modal: false,
        clinic: null
      },
      invoicesData: {
        modal: false,
        clinic: null
      },
      dataNewPassword: {
        modal: false,
        user: {}
      },
      dataCloneFromDoctor: {
        modal: false,
        toDoctor: null,
        fromDoctor: null
      },
      dataAddStaff: {
        modal: false,
        clinic: null
      },
      isProcessingActiveJoinClinic: false,
      // wi_staff_clinics.status : 0 deactive, 1 waiting, 2 confirmed, 3 remove, 4 hidden, 5 cancel
      STATUS_JOIN_WAITING: 1,
      STATUS_JOIN_CONFIRMED: 2,
      JOIN_CLINIC_STATUS_TEXT: {
        0: 'Deactivated',
        1: 'Waiting',
        2: 'Confirmed',
        3: 'Removed',
        4: 'Hidden',
        5: 'Cancelled'
      }
    }
  },
  computed: {
    getPageName () {
      return 'Clinic'
    }
  },
  watch: {},
  updated () {
  },
  mounted () {
    if (this.$route.name === 'list-group') {
      this.typePage = 'LIST_GROUP'
    }
    this.loadListDoctor()
  },
  beforeDestroy () {
  },
  methods: {
    showModalSetNewPassword (doctor) {
      this.dataNewPassword.modal = true
      this.dataNewPassword.user = doctor
    },
    showModalCreatePackage (doctor) {
      this.orderPackageData.modal = true
      this.orderPackageData.clinic = doctor
    },
    showModalInvoices (doctor) {
      this.invoicesData.clinic = doctor
      this.invoicesData.modal = true
    },
    showIdProof (doctor) {
      this.detailIdProof.user = doctor
      this.detailIdProof.modal = true
    },
    // list member
    showListMember (doctor) {
      doctor.opened = !doctor.opened
      doctor.paginatePhysician = this.$options.data().paginate
      doctor.paginateStaff = this.$options.data().paginate
      doctor.paginateMidLevel = this.$options.data().paginate
      doctor.paginateBoard = this.$options.data().paginate
      this.loadListMember(doctor, 'physician')
      this.loadListMember(doctor, 'staff')
      this.loadListMember(doctor, 'board')
      this.loadListMember(doctor, 'midLevel')
    },
    updatePerPageDoctor (data, doctor, type) {
      if (type === 'physician') {
        doctor.paginatePhysician.perPage = data.perPage
        doctor.paginatePhysician.page = data.currentPage
        this.loadListMember(doctor, type)
      }
      if (type === 'staff') {
        doctor.paginateStaff.perPage = data.perPage
        doctor.paginateStaff.page = data.currentPage
        this.loadListMember(doctor, type)
      }
      if (type === 'midLevel') {
        doctor.paginateMidLevel.perPage = data.perPage
        doctor.paginateMidLevel.page = data.currentPage
        this.loadListMember(doctor, type)
      }
      if (type === 'board') {
        doctor.paginateBoard.perPage = data.perPage
        doctor.paginateBoard.page = data.currentPage
        this.loadListMember(doctor, type)
      }
    },
    async loadListMember (doctor, type) {
      if (doctor.isLoadingPhysician && type === 'physician') {
        return
      }
      let page = doctor.paginatePhysician.page
      let perPage = doctor.paginatePhysician.perPage
      if (type === 'board') {
        page = doctor.paginateBoard.page
        perPage = doctor.paginateBoard.perPage
      }
      if (type === 'staff') {
        page = doctor.paginateStaff.page
        perPage = doctor.paginateStaff.perPage
      }
      if (type === 'midLevel') {
        page = doctor.paginateMidLevel.page
        perPage = doctor.paginateMidLevel.perPage
      }
      let params = {
        page: page,
        perPage: perPage,
        userId: doctor.id,
        typeStaff: type
      }
      this.setLoadingMember(doctor, type, true)
      let response = await axios.get(`/users/list-member-clinic`, { params: params })
      this.setLoadingMember(doctor, type, false)
      try {
        if (response.data.s === 200) {
          let dataDoctors = response.data.data.members ? response.data.data.members : []
          if (type === 'physician') {
            doctor.listPhysician = dataDoctors
            doctor.paginatePhysician.page = Number(response.data.data.currentPage)
            doctor.paginatePhysician.total = response.data.data.total
            doctor.paginatePhysician.totalPages = Math.ceil(doctor.paginatePhysician.total / doctor.paginatePhysician.perPage)
          }
          if (type === 'board') {
            doctor.listBoard = dataDoctors
            doctor.paginateBoard.page = Number(response.data.data.currentPage)
            doctor.paginateBoard.total = response.data.data.total
            doctor.paginateBoard.totalPages = Math.ceil(doctor.paginateBoard.total / doctor.paginateBoard.perPage)
          }
          if (type === 'staff') {
            doctor.listStaff = dataDoctors
            doctor.paginateStaff.page = Number(response.data.data.currentPage)
            doctor.paginateStaff.total = response.data.data.total
            doctor.paginateStaff.totalPages = Math.ceil(doctor.paginateStaff.total / doctor.paginateStaff.perPage)
          }
          if (type === 'midLevel') {
            doctor.listMidLevel = dataDoctors
            doctor.paginateMidLevel.page = Number(response.data.data.currentPage)
            doctor.paginateMidLevel.total = response.data.data.total
            doctor.paginateMidLevel.totalPages = Math.ceil(doctor.paginateMidLevel.total / doctor.paginateMidLevel.perPage)
          }
        } else {
          //            this.alertError('Server error when load member. F5 and refresh browser')
        }
      } catch (e) {
        this.setLoadingMember(doctor, type, false)
      }
    },
    getJoinClinicStatusText (status) {
      let text = this.JOIN_CLINIC_STATUS_TEXT[Number(status)]
      return text !== undefined ? text : 'Unknown'
    },
    setLoadingMember (doctor, type, value) {
      if (type === 'physician') {
        doctor.isLoadingPhysician = value
      } else if (type === 'staff') {
        doctor.isLoadingStaff = value
      } else if (type === 'midLevel') {
        doctor.isLoadingMidLevel = value
      } else if (type === 'board') {
        doctor.isLoadingBoard = value
      }
    },
    // end list member
    showDetailUser (user) {
      if (user.role === 'AllergyClinic') {
        this.detailClinic.modal = true
        this.detailClinic.user = user
      }
      if (user.role === 'GROUP') {
        this.detailGroup.modal = true
        this.detailGroup.user = user
      }
      if (user.role === 'RegularUser') {
        this.detailRegular.modal = true
        this.detailRegular.user = user
      }
      if (['physician', 'allergist'].indexOf(user.role) > -1) {
        this.detailDoctor.modal = true
        this.detailDoctor.user = user
      }
    },
    filterDoctor () {
      this.paginate.page = 1
      this.loadListDoctor()
    },

    updatePerPage (data) {
      this.paginate.perPage = data.perPage
      this.paginate.page = data.currentPage
      this.loadListDoctor()
    },
    async loadListDoctor () {
      if (this.isLoading) {
        return
      }
      this.isLoading = true
      let params = {
        page: this.paginate.page,
        perPage: this.paginate.perPage,
        keySearch: this.formSearch.keySearch,
        status: this.formSearch.status,
        typePage: this.typePage
      }
      let response = await axios.get(`/users/list`, { params: params })
      this.isLoading = false
      try {
        if (response.data.s === 200) {
          let dataDoctors = response.data.data.users ? response.data.data.users : []
          dataDoctors.map(item => {
            item.opened = false

            item.listPhysician = []
            item.paginatePhysician = {
              perPage: 10,
              page: 1,
              totalPages: 10,
              total: 0
            }
            item.listStaff = []
            item.paginateStaff = {
              perPage: 10,
              page: 1,
              totalPages: 10,
              total: 0
            }
            item.listMidLevel = []
            item.paginateMidLevel = {
              perPage: 10,
              page: 1,
              totalPages: 10,
              total: 0
            }
            item.listBoard = []
            item.paginateBoard = {
              perPage: 10,
              page: 1,
              totalPages: 10,
              total: 0
            }
            item.isLoadingPhysician = false
            item.isLoadingStaff = false
            item.isLoadingMidLevel = false
            item.isLoadingBoard = false
            return item
          })
          this.dataDoctors = dataDoctors
          this.paginate.page = Number(response.data.data.currentPage)
          this.paginate.total = response.data.data.total
          this.paginate.totalPages = Math.ceil(this.paginate.total / this.paginate.perPage)
        } else {
          this.alertError('Server error when load data clinic. F5 and refresh browser')
        }
      } catch (e) {
        this.isLoading = false
      }
    },
    showModalAddStaff (clinic) {
      this.dataAddStaff.clinic = clinic
      this.dataAddStaff.modal = true
    },
    reloadMemberOfClinic (clinic) {
      if (!clinic) {
        return
      }
      // clinic chưa mở thì mở ra luôn để thấy staff vừa add
      if (!clinic.opened) {
        this.showListMember(clinic)
        return
      }
      this.loadListMember(clinic, 'physician')
      this.loadListMember(clinic, 'staff')
      this.loadListMember(clinic, 'board')
      this.loadListMember(clinic, 'midLevel')
    },
    showModalCloneFromOtherDoctor (doctor) {
      this.dataCloneFromDoctor.modal = true
      this.dataCloneFromDoctor.toDoctor = doctor
    },
    async loginAsEmr (user) {
      try {
        let response = await httpClient.post(`/users/login-as-emr`, {
          userId: user.id
        })
        if (response.data.s === 200) {
          window.open(response.data.data.redirectUrl, '_blank')
          return
        }
        this.alertError(response.data.msg)
      } catch (e) {
        this.alertException(e)
      }
    },
    async activeJoinClinic(doctor, clinic) {
      if (this.isProcessingActiveJoinClinic) {
        return
      }
      try {
        this.isProcessingActiveJoinClinic = true
        let response = await httpClient.post(`/users/active-join-member`,
            {
              memberId: doctor.id,
              clinicId: clinic.id
            }
        )
        this.isProcessingActiveJoinClinic = false
        if (response.data.s !== 200) {
          this.alertError(response.data.msg)
          return
        }
        doctor.status = this.STATUS_JOIN_CONFIRMED
        this.$forceUpdate()
        this.alertSuccess('Active join clinic success')
      } catch (e) {
        this.isProcessingActiveJoinClinic = false
        this.alertException(e)
      }
    }
  }
}
</script>
<style>

</style>
<style scoped="">
    .avatar-user {
        width: 20px !important;
        padding-bottom: 20px !important;
        display: inline-block !important;
        border-radius: 50% !important;
        vertical-align: middle !important;
        background-size: cover;
        background-position: top center;
        height: 0;
        background-color: #e1e1e1;
        overflow: hidden;
    }

    .item-name {
        width: 15% !important;
        min-height: 1px;
        cursor: pointer;
    }

    .item-dob {
        width: 10% !important;
        min-height: 1px;
    }

    .item-created-at {
        width: 10% !important;
    }

    .item-provider {
        width: 6% !important;
        text-align: left !important;
    }

    .bank-linked {
        color: #2e7d32;
    }

    .bank-missing {
        color: #9e9e9e;
    }

    .item-proof {
        width: 10% !important;
        text-align: center !important;
        cursor: pointer;
    }

    .item-account-status {
        width: 10% !important;
        text-align: center !important;
    }

    .item-emr-status {
        width: 10% !important;
        text-align: center !important;
    }
/*==*/

    /* .list-members bị thụt vào 5%, nên width member = width parent / 0.95
       để các cột khớp thẳng hàng với header của bảng clinic ở trên */
    .item-member-name {
        width: 16% !important;
        min-height: 1px;
        cursor: pointer;
        float: left;
    }
    .item-member-dob {
        width: 7% !important;
        min-height: 1px;
        float: left;
    }

    .item-member-created-at {
        width: 10.68% !important;
        float: left;
    }

    /* thẳng hàng với cột "Account status" của parent (bắt đầu ở 37%) */
    .item-member-account-status {
        width: 10.53% !important;
        float: left;
        text-align: center !important;
    }

    /* margin-left = bề rộng cột "Email status" của parent (bị bỏ trống) */
    .item-member-emr-status {
        width: 10.53% !important;
        margin-left: 10.53%;
        float: left;
        text-align: center !important;
    }

    .item-action {
        width: 10% !important;
        float: right;
        min-height: 1px;
        text-align: right !important;
        padding-right: 10px;
    }

    .clinic-actions {
        display: grid;
        grid-template-columns: max-content max-content;
        justify-content: end;
        align-items: start;
        gap: 4px 10px;
        text-align: left !important;
    }

    .clinic-actions > .btn-group {
        grid-column: 1;
        white-space: nowrap;
    }

    .clinic-actions > .clinic-settings {
        grid-column: 2;
        grid-row: 1 / span 2;
    }

    .onelineform {
        border-left: none !important;
    }

    .item-folder:before {
        content: "\f07b";
        font-family: "Font Awesome\ 5 Free";
        color: #faaf3a;
        font-weight: 900;
        font-size: 16px;
        margin-right: 5px;
        cursor: pointer;
    }

    .item-folder.opened:before {
        content: "\f07c" !important;
    }

    .list-members .itemlisthead {
        /*background: #efefef;*/
        background: inherit !important;
        clear: both
    }

    .list-members {
        width: 100% !important;
        padding-left: 5%;
        background: inherit !important;
    }

    .list-members .item-member-name {
    }

    .item-member {
        border-bottom: none !important;
        padding: 10px 0;
        vertical-align: top;
    }

    .block-member {
        margin-top: 10px;
    }
    .itemlisttable > div.itemlisthead {
        vertical-align: top;
        padding: 10px 0;
        border-bottom: 1px solid #e1e1e1;
    }
    .list-members .item-member-name {
        padding-left: 10px;
    }

    /* trạng thái join clinic (wi_staff_clinics.status), hiển thị dưới tên member */
    .member-join-status {
        padding-left: 25px;
        font-size: 10px;
        font-style: italic;
        font-weight: normal !important;
        color: #999;
    }

    .member-join-status.not-confirmed {
        color: #e74c3c;
    }
</style>
